import type { CommitmentLineItem } from '@weft/types';
import { uniqueBy, sumBy } from '@weft/utils';

export function getTotalCommitment(lineItems: CommitmentLineItem[]) {
  const commitments = lineItems.map(({ lineItemProduct }) => lineItemProduct.commitment!);
  const uniqueCommitments = uniqueBy(commitments, 'commitmentId');
  
  return sumBy(uniqueCommitments, ({ consumption }) => consumption);
}